import * as yup from 'yup';

import { Value } from 'features/users/components/organisms/TagsInput';

import { YUP_FIELDS } from 'shared/utilities/yupFieldUtility';

import { MAX_NAME_LENGTH, MAX_SLOGAN_LENGTH } from '../NewAccountForm/config';

export const ACCOUNT_DETAILS_FIELD_NAMES = {
  NAME: 'name',
  DOMAIN: 'domain',
  SLOGAN: 'slogan',
  TAGS: 'tags',
};

export interface AccountDetailsValues {
  name: string;
  domain: string;
  slogan: string;
  tags: Value[];
}

export const accountDetailsSchema = yup.object({
  name: yup.string().customRequiredString().max(MAX_NAME_LENGTH),
  domain: YUP_FIELDS.DOMAIN_REQUIRED,
  slogan: yup.string().max(MAX_SLOGAN_LENGTH),
  tags: yup.array(
    yup.object().shape({
      category: yup.string(),
      values: yup.array().of(yup.string()),
    }),
  ),
});
